(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("learningJournalLearnerAccess", {
        templateUrl: "app/account/learnerAccess/learningItemType/learningJournalLearnerAccess.component.html",
        require: {
            parentCtrl: "^^learningItemLearnerAccessModal"
        },
        controller: ["assignmentLearnerAccessLearningJournalResource", "messageService", "Upload", "$timeout", "$uibModal", "$state", LearningJournalLearnerAccessCtrl],
        controllerAs: "vm"
    });
    function LearningJournalLearnerAccessCtrl(assignmentLearnerAccessLearningJournalResource, messageService, Upload, $timeout, $uibModal, $state) {
        var vm = this;
        vm.removeDisabled = false;
        vm.number = $state.params.number;
        vm.version = $state.params.version;
        vm.code = $state.params.code;
        this.$onInit = function () {
            vm.assignment = vm.parentCtrl.assignment;
            load();
        };
        ////////////////////////////////////////////////////////////////////////////////
        function load() {
            vm.journal = assignmentLearnerAccessLearningJournalResource.get({ id: vm.assignment.id }, function () {
                switch (vm.assignment.assignmentStatus) {
                    case 0:
                        break;
                    case 1:
                    case 2:
                        setupLearningItem();
                        break;
                    case 3:
                        if (vm.assignment.expiring)
                            setupRequalifyButton();
                        break;
                    case 4:
                        setupRequalifyButton();
                        break;
                }
                vm.parentCtrl.contentLoaded = true;
            });
        }
        function setupLearningItem() {
            vm.parentCtrl.buttons = "uploadButton";
            vm.parentCtrl.uploadJournal = vm.uploadJournal;
        }
        function setupRequalifyButton() {
            vm.parentCtrl.buttons = "requalifyButton";
            vm.parentCtrl.requalify = vm.requalify;
        }
        vm.removeFile = function (file) {
            vm.removeDisabled = true;
            var confirmationModal = $uibModal.open({
                templateUrl: "deleteJournalFile.tpl",
                windowClass: "confirmation-modal"
            });
            confirmationModal.result.then(function () {
                assignmentLearnerAccessLearningJournalResource.deleteFile({ id: vm.assignment.id, fileId: file.id }, function () {
                    vm.assignment.assignmentStatus = 1;
                    vm.assignment.expired = false;
                    vm.parentCtrl.assignmentStatusClass = "assigned";
                    vm.assignment.expiring = false;
                    vm.journal.resultFiles = [];
                    setupLearningItem();
                }, function () {
                    vm.removeDisabled = false;
                    messageService.error("common.genericError");
                });
            }, function () {
                vm.removeDisabled = false;
            });
        };
        vm.requalify = function () {
            vm.parentCtrl.requalifyClicked = true;
            vm.assignment.$requalify({ number: $state.params.number, version: $state.params.version, code: $state.params.code }, function () {
                vm.parentCtrl.load();
            }, function () {
                messageService.error("common.genericError");
            });
        };
        vm.uploadJournal = function (file) {
            if (file) {
                vm.parentCtrl.file = file;
                file.upload = Upload.upload({
                    url: "/api/learningJournalAssignments/" + vm.assignment.id,
                    data: { file: file }
                });
                file.upload.then(function () {
                    $timeout(function () {
                        vm.parentCtrl.file.progress = 0;
                        vm.progress = 0;
                        vm.parentCtrl.dismiss();
                    });
                }, function (error) {
                    messageService.error(error);
                    vm.parentCtrl.file.progress = 0;
                    vm.progress = 0;
                }, function (evt) {
                    vm.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    vm.parentCtrl.file.progress = vm.progress;
                });
            }
            else {
                messageService.error("common.error.invalidFileType");
            }
        };
    }
}());
